import { ALL_THERAME_EVENT_TYPES } from '../../events/event.base.js';
/**
 * Validation invariants enforced at registry boot. Surface errors there so
 * a typo in a registry entry fails the app rather than going silent.
 */
export class ChallengeDefinitionInvalidError extends Error {
    constructor(message) {
        super(message);
        this.name = 'ChallengeDefinitionInvalidError';
    }
}
export const validateChallengeDefinition = (def) => {
    if (!def.id || !def.tasks.length) {
        throw new ChallengeDefinitionInvalidError(`Challenge "${def.id}" must have a non-empty id and at least one task`);
    }
    const seenTaskIds = new Set();
    for (const task of def.tasks) {
        if (!task.id) {
            throw new ChallengeDefinitionInvalidError(`Challenge "${def.id}" has a task without an id`);
        }
        if (seenTaskIds.has(task.id)) {
            throw new ChallengeDefinitionInvalidError(`Challenge "${def.id}" has duplicate task id "${task.id}"`);
        }
        seenTaskIds.add(task.id);
        if (!task.conditions.length) {
            throw new ChallengeDefinitionInvalidError(`Challenge "${def.id}" task "${task.id}" has no goal conditions`);
        }
        for (const cond of task.conditions) {
            if (!ALL_THERAME_EVENT_TYPES.includes(cond.eventType)) {
                throw new ChallengeDefinitionInvalidError(`Challenge "${def.id}" task "${task.id}" references unknown event type "${cond.eventType}"`);
            }
            if (cond.minCount !== undefined && cond.minCount < 1) {
                throw new ChallengeDefinitionInvalidError(`Challenge "${def.id}" task "${task.id}" condition minCount must be >= 1`);
            }
        }
    }
};
/**
 * Collect every event type referenced by any goal in any registered
 * challenge. Used to seed the capture listener's `@OnTherameEvent` decorator.
 */
export const collectListenedEventTypes = (defs) => {
    const set = new Set();
    for (const def of defs) {
        for (const task of def.tasks) {
            for (const cond of task.conditions) {
                set.add(cond.eventType);
            }
        }
    }
    return [...set];
};
//# sourceMappingURL=challenge-definition.js.map